import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {selectedPresentationSelector} from '../../../../../../store/selectors/presentation.selectors';
import {IElementQuestionAnswer, IElementQuestionnaireWithAnswers} from '../../../../../../incase-domain/elements/base/questionElementBase';
import {isRuleInFocus} from '../../../../../../utils/rule';
import AppliedRuleSlideSelector from '../../../common/AppliedRuleSlideSelector';
import {IElementQuestion} from '../../../../../../incase-domain/elements/question/question';
import {IElementQuestionYesNo} from '../../../../../../incase-domain/elements/question/questionYesNo';
import {IElementPhotoAnswerQuestion} from '../../../../../../incase-domain/elements/question/photoAnswerQuestion';
import {IElementMultiSelect} from '../../../../../../incase-domain/elements/question/multiSelect';
import Modal from '../../../../../../incase-domain/components/modals/directory/Modal';
import {getAnswer} from '../../../../../../utils/codebook.utils';
import Button from '../../../../../../incase-domain/components/button/Button';

interface IAnswerRulesProps {
    index: number;
    highlightedElement: IElementQuestionnaireWithAnswers;
    codebookAnswer?: IElementQuestionAnswer;
}

function AnswerRules({index, highlightedElement, codebookAnswer}: IAnswerRulesProps): JSX.Element {
    const {t} = useTranslation();
    const presentation = useSelector(selectedPresentationSelector);
    const {appliedRules} = presentation;

    const [isRulesModalOpen, setIsRulesModalOpen] = React.useState(false);
    const appliedRule = appliedRules?.find((r) => isRuleInFocus(r, highlightedElement.id, codebookAnswer?.codebookEntryId || index));

    return (
        <>
            <Button
                leading={appliedRule ? 'solar:branching-paths-up-bold' : 'solar:branching-paths-up-linear'}
                variant="ghost"
                square
                color={appliedRule ? 'secondary' : 'primary'}
                size="sm"
                key={`${index}-branching`}
                onClick={() => setIsRulesModalOpen(true)}
            />

            <Modal
                isOpen={isRulesModalOpen}
                onCancel={() => {
                    setIsRulesModalOpen(false);
                }}
                onConfirm={() => {
                    setIsRulesModalOpen(false);
                }}
                description={`${t('designSidepanel.joinRuleToAnswer')}`}
                header={`"${getAnswer(index, highlightedElement, codebookAnswer).text}"`}
                icon="solar:branching-paths-up-bold"
                showConfirm
            >
                <AppliedRuleSlideSelector
                    key={highlightedElement.id}
                    element={
                        highlightedElement as IElementQuestion | IElementQuestionYesNo | IElementPhotoAnswerQuestion | IElementMultiSelect
                    }
                    answerIndex={index}
                    codebookAnswer={codebookAnswer}
                />
            </Modal>
        </>
    );
}

export default AnswerRules;
